let initialState = {
  info: [],
  warning: [],
  critical: [],
  success: [],
};

export default function reducer( state = initialState, action ) {
  var index = 0;
  switch( action.type ) {
  case 'NOTIFICATION_INFO': {
    let info = state.info;
    info.push( action.payload );
    state = {...state, info: info };
    break;
  }
  case 'REMOVE_NOTIFICATION_INFO': {
    let info = state.info;
    let newinfo = [];
    if( info !== undefined ) {
      if( info.length > 0 ) {
        for( index = 0; index < info.length; index++ ) {
          if( action.payload.key !== info[ index ].key ) {
            newinfo.push( info[ index ] );
          }
        }
      }
    }
    state = { ...state, info: newinfo };
    break;
  }
  case 'NOTIFICATION_WARNING': {
    let warning = state.warning;
    warning.push( action.payload );
    state = {...state, warning: warning };
    break;
  }
  case 'REMOVE_NOTIFICATION_WARNING': {
    let warning = state.warning;
    let newwarning = [];
    if( warning !== undefined ) {
      if( warning.length > 0 ) {
        for( index = 0; index < warning.length; index++ ) {
          if( action.payload.key !== warning[ index ].key ) {
            newwarning.push( warning[ index ] );
          }
        }
      }
    }
    state = { ...state, warning: newwarning };
    break;
  }
  case 'NOTIFICATION_CRITICAL': {
    let critical = state.critical;
    critical.push( action.payload );
    state = {...state, critical: critical };
    break;
  }
  case 'REMOVE_NOTIFICATION_CRITICAL': {
    let critical = state.critical;
    let newcritical = [];
    if( critical !== undefined ) {
      if( critical.length > 0 ) {
        for( index = 0; index < critical.length; index++ ) {
          if( action.payload.key !== critical[ index ].key ) {
            newcritical.push( critical[ index ] );
          }
        }
      }
    }
    state = { ...state, critical: newcritical };
    break;
  }
  case 'NOTIFICATION_SUCCESS': {
    let success = state.success;
    success.push( action.payload );
    state = {...state, success: success };
    break;
  }
  case 'REMOVE_NOTIFICATION_SUCCESS': {
    let success = state.success;
    let newsuccess = [];
    if( success !== undefined ) {
      if( success.length > 0 ) {
        for( index = 0; index < success.length; index++ ) {
          if( action.payload.key !== success[ index ].key ) {
            newsuccess.push( success[ index ] );
          }
        }
      }
    }
    state = { ...state, success: newsuccess };
    break;
  }
  default:
    return state;
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/notifications.js